module.exports = __webpack_public_path__ + "img/points-icon.722a5371.svg";